import { OktaAuth } from "@okta/okta-auth-js";
import authorizationConfig from "../environment-property/property.json";
import jwt from "jwt-decode";

class AuthService {
  constructor() {
    this.tokenCacheKey =
      authorizationConfig.authConfiguration.tokenCacheKey;

    this.oktaAuth = new OktaAuth({
      issuer: authorizationConfig.authConfiguration.okta.issuer,
      clientId: authorizationConfig.authConfiguration.okta.clientId,
      redirectUri: authorizationConfig.authConfiguration.okta.redirectUri,
      scopes: authorizationConfig.authConfiguration.okta.scopes,
      tokenManager: { storage: "localStorage" },
    });
  }

  async initLogin() {
    const params = new URLSearchParams(window.location.search);

    if (params.get("code") || params.get("state") || params.get("id_token")) {
      const tokenResponse = await this.oktaAuth.token.parseFromUrl();

      const accessToken = tokenResponse.tokens.accessToken?.accessToken;
      const idToken = tokenResponse.tokens.idToken?.idToken;

      localStorage.setItem(this.tokenCacheKey, accessToken);
      localStorage.setItem("idToken", idToken);

      window.history.replaceState({}, document.title, "/");
      return true;
    }

    const cached = localStorage.getItem(this.tokenCacheKey);

    if (cached && Date.now() < jwt(cached).exp * 1000) {
      return true;
    }

    this.login();
    return false;
  }

  async getToken() {
    const cached = localStorage.getItem(this.tokenCacheKey);

    if (cached && Date.now() < jwt(cached).exp * 1000) {
      return cached;
    }

    const tokenResponse = await this.oktaAuth.token.getWithoutPrompt({
      scopes: authorizationConfig.authConfiguration.okta.scopes,
    });

    const token = tokenResponse.tokens.accessToken.accessToken;
    localStorage.setItem(this.tokenCacheKey, token);

    return token;
  }

  login() {
    this.oktaAuth.token.getWithRedirect({
      scopes: authorizationConfig.authConfiguration.okta.scopes,
    });
  }

  logout() {
    localStorage.clear();
    this.oktaAuth.signOut();
  }
}

export default AuthService;